import React, { useState } from "react";
import cursor1 from "../../assets/cursor1.png";
import step1 from "../../assets/step1.png";
import step2 from "../../assets/step2.png";
import step3 from "../../assets/step3.png";
import step4 from "../../assets/step4.png";
import step5 from "../../assets/step5.png";
import { useTranslation } from "react-i18next";

const Steps = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div>
      <div className="mt-24 relative flex items-start">
        <h3 className="text-[#14294F] text-2xl font-semibold">
          {t("As Simple As A Click")}
        </h3>
        <img
          src={cursor1}
          className="w-[130px] max-lg:w-[80px] z-10 relative -top-10 ml-3"
        />
      </div>
      <p className="text-[#737E91] text-lg w-3/5 max-lg:w-full relative -top-5 max-lg:top-0">
        {t("Start booking your service order and find the nearest professionals with the click of a button.")}
      </p>

      <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-10 mt-5">
        <div>
          <div className="flex items-center">
            <div className="bg-[#FCFBFA] text-[#EAA182] p-5 w-[70px] h-[70px] text-2xl rounded-full text-center">
              1
            </div>
            <p className={`text-[#283D63] text-2xl font-semibold ${language == "en" ? "ml-5" : "mr-5"}`}>
              {t("Step 1")}
            </p>
          </div>
          <img src={step1} className="mt-5 h-[75px]" alt="Step 1" />
          <p className="text-[#737E91] text-xl mt-5 text-center">
            {t("Choose the service and the sub-service")}
          </p>
        </div>
        <div>
          <div className="flex items-center">
            <div className="bg-[#FCFBFA] text-[#EAA182] p-5 w-[70px] h-[70px] text-2xl rounded-full text-center">
              2
            </div>
            <p className={`text-[#283D63] text-2xl font-semibold ${language == "en" ? "ml-5" : "mr-5"}`}>
              {t("Step 2")}
            </p>
          </div>
          <img src={step2} className="mt-5 h-[75px]" alt="Step 2" />
          <p className="text-[#737E91] text-xl mt-5 text-center">
            {t("Add your detailed address")}
          </p>
        </div>
        <div>
          <div className="flex items-center">
            <div className="bg-[#FCFBFA] text-[#EAA182] p-5 w-[70px] h-[70px] text-2xl rounded-full text-center">
              3
            </div>
            <p className={`text-[#283D63] text-2xl font-semibold ${language == "en" ? "ml-5" : "mr-5"}`}>
              {t("Step 3")}
            </p>
          </div>
          <img src={step3} className="mt-5 h-[75px]" alt="Step 3" />
          <p className="text-[#737E91] text-xl mt-5 text-center">
            {t("Schedule a suitable date & time")}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mx-auto mt-10 text-center lg:flex lg:justify-center">
        <div>
          <div className="flex items-center">
            <div className="bg-[#FCFBFA] text-[#EAA182] p-5 w-[70px] h-[70px] text-2xl rounded-full text-center">
              4
            </div>
            <p className={`text-[#283D63] text-2xl font-semibold ${language == "en" ? "ml-5" : "mr-5"}`}>
              {t("Step 4")}
            </p>
          </div>
          <img src={step4} className="mt-5" alt="Step 4" />
          <p className="text-[#737E91] text-xl mt-5 text-center">
            {t("Explain the issue you’re facing")}
          </p>
        </div>
        <div>
          <div className="flex items-center mb-8">
            <div className="bg-[#FCFBFA] text-[#EAA182] p-5 w-[70px] h-[70px] text-2xl rounded-full text-center">
              5
            </div>
            <p className={`text-[#283D63] text-2xl font-semibold ${language == "en" ? "ml-5" : "mr-5"}`}>
              {t("Step 5")}
            </p>
          </div>
          <img src={step5} className="mt-5 w-[220px]" alt="Step 5" />
          <p className="text-[#737E91] text-xl mt-5 text-center">
            {t("Hit BOOK")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Steps;
